/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=0cd8d926&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=0cd8d926&lang=scss&scoped=true"

import exportComponent from "/Users/zhangmengxuan/Desktop/xinyan-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd8d926"]])

export default __exports__